import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import {
  HomePage,
  NotFound,
  FAQsPage,
  PricingPage,
  SignUpPage,
  ThankYouPage,
} from "@/pages";
import { LandingLayout } from "@/components";
import { AppProvider } from "./hooks";
import Intercom from "@intercom/messenger-js-sdk";

export default () => {
  Intercom({
    app_id: "itnqa49d",
  });

  return (
    <BrowserRouter>
      <AppProvider>
        <Routes>
          <Route
            path="/"
            element={
              <LandingLayout>
                <HomePage />
              </LandingLayout>
            }
          />

          <Route
            path="/faqs"
            element={
              <LandingLayout>
                <FAQsPage />
              </LandingLayout>
            }
          />

          <Route
            path="/pricing"
            element={
              <LandingLayout>
                <PricingPage />
              </LandingLayout>
            }
          />

          <Route
            path="/thank-you"
            element={
              <LandingLayout>
                <ThankYouPage />
              </LandingLayout>
            }
          />

          <Route path="/sign-up" element={<SignUpPage />} />

          <Route path="/404" element={<NotFound />} />

          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </AppProvider>
    </BrowserRouter>
  );
};
